class ProductCalculator {
  constructor() {
    this.resetFields();
    this.bindEvents();
  }

  resetFields() {
    // Reset main product fields
    document.querySelectorAll('[id*=area_needed]').forEach(el => el.value = "");
    document.querySelectorAll('.product_price_overage_new').forEach(el => el.textContent = "");
    document.querySelectorAll('.qty').forEach(el => el.value = 1);
    const sampleQty = document.querySelector('[id*=sample_quantity]');
    if (sampleQty) sampleQty.value = 1;
    
    // Reset calculator fields
    document.querySelectorAll('#ft_need').forEach(el => el.value = "");
    document.querySelectorAll('#finalquantity').forEach(el => el.value = 1);
  }

  bindEvents() {
    // Main product area needed input
    document.addEventListener('change', (e) => {
      if (e.target.matches('#ft_need')) {
        this.handleAreaNeeded(e.target.value);
      }
      if (e.target.matches('#finalquantity')) {
        this.handleFinalQuantity(e.target.value);
      }
    });
    document.addEventListener('keyup', (e) => {
      if (e.target.matches('#ft_need')) {
        this.handleAreaNeeded(e.target.value);
      }
      if (e.target.matches('#finalquantity')) {
        this.handleFinalQuantity(e.target.value);
      }
    });
    // Modal area needed input
    document.addEventListener('change', (e) => {
      if (e.target.closest('.modal__inner [id*=ft_need-modal]')) {
        this.handleModalAreaNeeded(e);
      }
    });
    document.addEventListener('keyup', (e) => {
      if (e.target.closest('.modal__inner [id*=ft_need-modal]')) {
        this.handleModalAreaNeeded(e);
      }
    });
    
    // Listen for variant changes
    document.addEventListener('variant:change', () => {
      this.handleVariantChange();
    });
    
    // Also listen for custom variant change events
    document.addEventListener('variant:updated', () => {
      this.handleVariantChange();
    });
    
    // Listen for Alpine.js variant changes
    document.addEventListener('alpine:init', () => {
      if (window.Alpine) {
        window.Alpine.store('xVariantSelect', {
          ...window.Alpine.store('xVariantSelect'),
          onVariantChange: () => {
            this.handleVariantChange();
          }
        });
      }
    });
  }

  handleFinalQuantity(val) {
    if (!val) return;
    const v_id = this.getInputValueByName('id');
    const variant = window.meta?.product?.variants?.find(item => String(item.id) === String(v_id));
    document.querySelectorAll('#finalquantity').forEach(el => el.value = val);
    document.querySelectorAll('.product__quantity input[name="quantity"]').forEach(el => el.value = val);
    if (variant) {
      const price = variant.price;
      const total_price = parseFloat(price * val);
      const tot_price = this.formatMoney(total_price);
      document.querySelectorAll('.total-value').forEach(el => {
        el.innerHTML = tot_price;
      });
    }
  }

  handleAreaNeeded(val) {
    if (!val) return;
    const actual_area_el = document.querySelector('#area_actual');
    if (!actual_area_el) return;
    const actual_area = parseFloat(actual_area_el.innerHTML);
    const overage_sq_ft = parseFloat(val);
    const total_sq_ft_needed = Number(overage_sq_ft.toFixed(2));
    const SQ_FT_per_box = Number(actual_area.toFixed(2));
    let tot_num_boxes = Number((total_sq_ft_needed / SQ_FT_per_box).toFixed(2));
    if (tot_num_boxes) {
      // Update finalquantity input
      tot_num_boxes = Math.ceil(tot_num_boxes);
      document.querySelectorAll('#finalquantity').forEach(el => el.value = tot_num_boxes);
      document.querySelectorAll('.product__quantity input[name="quantity"]').forEach(el => el.value = tot_num_boxes);
      const v_id = this.getInputValueByName('id');
      const variant = window.meta?.product?.variants?.find(item => String(item.id) === String(v_id));
      if (variant) {
        const price = variant.price;
        const total_price = parseFloat(price * tot_num_boxes);
        const tot_price = this.formatMoney(total_price);
        document.querySelectorAll('.total-value').forEach(el => {
          el.innerHTML = tot_price;
        });
        
        // Update Sqft Price display
        if (actual_area > 0) {
          const sqft_price = price / actual_area;
          const formatted_sqft_price = this.formatMoney(sqft_price);
          document.querySelectorAll('.calculator-value').forEach(el => {
            if (el.previousElementSibling && el.previousElementSibling.textContent.trim() === 'Sqft Price') {
              el.innerHTML = formatted_sqft_price;
            }
          });
          

        }
      }
    }
  }

  handleModalAreaNeeded(e) {
    e.preventDefault();
    const input = e.target;
    const _parent = input.closest('.modal__centered-content');
    if (!_parent) return;
    const currentValue = input.value;
    if (!currentValue) return;
    const actual_area = parseFloat(_parent.querySelector('[id*=area_actual-modal]')?.textContent || 0);
    const overage_sq_ft = parseFloat(currentValue);
    const total_sq_ft_needed = Number(overage_sq_ft.toFixed(2));
    const SQ_FT_per_box = Number(actual_area.toFixed(2));
    let tot_num_boxes = Number((total_sq_ft_needed / SQ_FT_per_box).toFixed(2));
    if (tot_num_boxes) {
      _parent.querySelectorAll('[id*=pp_overage_new_1-modal]').forEach(el => el.textContent = tot_num_boxes);
      tot_num_boxes = Math.ceil(tot_num_boxes);
      _parent.querySelectorAll('[id*=finalquantity-modal]').forEach(el => el.value = tot_num_boxes);
      _parent.querySelectorAll('.js-qty__wrapper input[name="quantity"]').forEach(el => el.value = tot_num_boxes);
      const v_id = _parent.querySelector('[name="name"]')?.value;
      const pId = _parent.querySelector('.product-section')?.getAttribute('data-product-id');
      if (!pId) return;
      const jsonEl = _parent.querySelector(`#wcp_json_${pId}-modal`);
      if (!jsonEl) return;
      let productDetails;
      try {
        productDetails = JSON.parse(jsonEl.textContent);
      } catch {
        return;
      }
      const variant = productDetails.variants.find(item => String(item.id) === String(v_id));
      if (variant) {
        const price = variant.price;
        const total_price = parseFloat(price * tot_num_boxes);
        const tot_price = this.formatMoney(total_price);
        _parent.querySelectorAll('[id*=total_price_2-modal]').forEach(el => {
          el.innerHTML = `<span class="amount">${tot_price}</span>`;
        });
      }
    }
  }

  handleVariantChange() {
    // Wait a bit for the DOM to update
    setTimeout(() => {
      this.updateAllPrices();
    }, 100);
  }

  updateAllPrices() {
    const calculatorWrapper = document.querySelector('.calculator-wrapper');
    if (!calculatorWrapper) return;
    
    const areaActual = parseFloat(calculatorWrapper.getAttribute('data-area-actual') || 0);
    const currentVariant = this.getCurrentVariant();
    
    if (currentVariant && areaActual > 0) {
      const price = currentVariant.price;
      
      // Update Sqft Price
      const sqftPrice = price / areaActual;
      const formattedSqftPrice = this.formatMoney(sqftPrice);
      document.querySelectorAll('.calculator-value').forEach(el => {
        if (el.previousElementSibling && el.previousElementSibling.textContent.trim() === 'Sqft Price') {
          el.innerHTML = formattedSqftPrice;
        }
      });
      
      // Update Price per Box (this should be the variant price)
      const formattedBoxPrice = this.formatMoney(price);
      document.querySelectorAll('.price_per_box').forEach(el => {
        el.innerHTML = formattedBoxPrice;
      });
      
      // Update Total Price if there's a current quantity
      const currentQuantity = document.querySelector('#finalquantity')?.value || 1;
      if (currentQuantity > 0) {
        const totalPrice = price * currentQuantity;
        const formattedTotalPrice = this.formatMoney(totalPrice);
        document.querySelectorAll('.total-value').forEach(el => {
          el.innerHTML = formattedTotalPrice;
        });
      }
      

    }
  }

  getCurrentVariant() {
    const v_id = this.getInputValueByName('id');
    if (!v_id) return null;
    
    // Try to get variant from window.meta first
    if (window.meta?.product?.variants) {
      const variant = window.meta.product.variants.find(item => String(item.id) === String(v_id));
      if (variant) return variant;
    }
    
    // Fallback: try to get from product JSON
    const productJson = document.querySelector('#ProductJson-product-template');
    if (productJson) {
      try {
        const productData = JSON.parse(productJson.textContent);
        const variant = productData.variants.find(item => String(item.id) === String(v_id));
        if (variant) return variant;
      } catch (e) {
        // Silent error handling for production
      }
    }
    
    return null;
  }

  getInputValueByName(name) {
    const el = document.querySelector(`[name="${name}"]`);
    return el ? el.value : null;
  }

  formatMoney(amount) {
    if (window.theme?.Currency?.formatMoney && window.theme?.settings?.moneyFormat) {
      return window.theme.Currency.formatMoney(amount, window.theme.settings.moneyFormat);
    }
    // fallback
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    }).format(amount / 100); // Shopify price is in cents
  }
}

// Initialize calculator when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductCalculator();
  });
} else {
  new ProductCalculator();
}

// Re-initialize calculator for dynamic content (AJAX)
document.addEventListener('shopify:section:load', () => {
  new ProductCalculator();
}); 